export const FORGOT_PASS_VIEW_FORM_FIELDS = {
  Email: 'email',
} as const;

export type ForgotPassViewFormValues = {
  [FORGOT_PASS_VIEW_FORM_FIELDS.Email]: string;
};
